import { render, staticRenderFns } from "./TableEmptyOccupations.vue?vue&type=template&id=677720a7&scoped=true&"
import script from "./TableEmptyOccupations.vue?vue&type=script&lang=js&"
export * from "./TableEmptyOccupations.vue?vue&type=script&lang=js&"
import style0 from "./TableEmptyOccupations.vue?vue&type=style&index=0&id=677720a7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "677720a7",
  null
  
)

export default component.exports